import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { createAutoSuggestion } from './AutoSuggestion';
import { AUTO_SUGGESTION_BASE_CLASSNAME } from './Constants';
createComponents(".".concat(AUTO_SUGGESTION_BASE_CLASSNAME), createAutoSuggestion, NO_PATTERN_BUSINESS_LOGIC);
